import { render, staticRenderFns } from "./GeneralPriceManagementFuel.vue?vue&type=template&id=476a6b9a&scoped=true&"
import script from "./GeneralPriceManagementFuel.vue?vue&type=script&lang=js&"
export * from "./GeneralPriceManagementFuel.vue?vue&type=script&lang=js&"
import style0 from "./GeneralPriceManagementFuel.vue?vue&type=style&index=0&id=476a6b9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476a6b9a",
  null
  
)

export default component.exports